export const dateExpiresInOneHour = (data: string) => {
  const currentDate = new Date();
  const dateExpires = new Date(data);
  var hours = Math.abs(dateExpires.getTime() - currentDate.getTime()) / 3600000;
  return hours < 1 && currentDate < dateExpires
};